import { ReactNode } from "react";
import { Route } from "react-router-dom";
import appRoutes from "./appRoutes";
import { RouteType } from "./RouteType";
import PageWrapper from "../components/layout/PageWrapper";

const generateRoute = (appRoutes: RouteType[], userRole: string): ReactNode => {
  const routesList: React.ReactElement[] = [];

  const routeMap = (routes: RouteType[]) => {
    routes.forEach((route) => {
      if (route.roles && route.roles.includes(userRole)) {
        routesList.push(
          <Route
            path={route.path}
            element={
              <PageWrapper state={route.state}>{route.element}</PageWrapper>
            }
            key={route.state}
          />
        );
      }
      if (route.children) {
        routeMap(route.children);
      }
    });
  };
  routeMap(appRoutes);

  return routesList;
};

export const  routes = (userRole: string): ReactNode => {
  return generateRoute(appRoutes, userRole);
};
